export default __webpack_public_path__ + "static/media/danskeheadlinebold-webfont.9ed2d4b0.woff";